export default {
  readMore: {
    id: 'core_read_more',
    defaultMessage: 'Read more',
  },
}
